<template>
  <div>
    <el-dialog
      v-bind="$attrs"
      v-on="$listeners"
      :close-on-click-modal="false"
      :title="$t('signIn.签到')"
      class="dialog-dark dialog-center signHeader"
      width="400px"
    >
      <div class="signin">
        <el-form
          ref="signIn"
          :model="formLabelAlign"
          :rules="rules"
          label-position="right"
          label-width="92px"
          size="small"
        >
          <el-form-item :label="$t('signIn.签到时长')" prop="duration">
            <el-input
              v-model.number="formLabelAlign.duration"
              :placeholder="$t('signIn.DP')"
              class="inputTime inputLong"
              type="number"
            ></el-input>
            <span class="second"> {{ $t("signIn.秒") }}</span>
          </el-form-item>
          <el-form-item :label="$t('signIn.签到提示语')" prop="title">
            <el-input
              v-model="formLabelAlign.title"
              :placeholder="$t('signIn.请输入提示语')"
              type="text"
              maxlength="30"
              show-word-limit
              class="inputLong"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('signIn.范围')" prop="scope">
            <el-checkbox-group v-model="formLabelAlign.scope">
              <el-checkbox :label="option.value" v-for="option in scopes" :key="option.value" class="check-label">
              {{ option.text }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="sign-btn_a">
        <el-button
          :disabled="formDis"
          type="primary"
          size="mini"
          @click="submitForm()"
          >{{ $t("signIn.开始签到") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { rollcall } from "@/api/liveRequest/rollcalls";
import { Dialog, Input, Button, Form, FormItem } from "element-ui";
import { mapGetters } from "vuex";
export default {
  name: "SignIn",
  components: {
    [Dialog.name]: Dialog,
    [Input.name]: Input,
    [Button.name]: Button,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
  },
  props: {
    limit: Number,
  },
  data() {
    return {
      formLabelAlign: {
        confId: "",
        title: this.$t("signIn.请签到"),
        duration: 10,
        scope: [1]
      },
      scopes: [
        { value: 1, text: this.$t('signIn.观众')},
        { value: 2, text: this.$t('signIn.嘉宾')}
      ]
    };
  },
  computed: {
    ...mapGetters(["liveRoomStatus"]),
    formDis() {
      return (
        this.formLabelAlign.title === "" || this.formLabelAlign.duration === ""
      );
    },
    rules() {
      return {
        title: [
          {
            required: true,
            message: this.$t("signIn.请输入提示语"),
            trigger: "blur",
          },
        ],
        duration: [
          {
            required: true,
            message: this.$t("signIn.请输入签到时长"),
            trigger: "blur",
          },
          {
            type: "number",
            message: this.$t("signIn.签到时长须为10-999整数"),
            max: 999,
            min: 10,
          },
        ]
      };
    },
  },
  methods: {
    handleCheckedChange(val) {
      console.log(val, "vla....")
    },
    submitForm() {
      if (this.liveRoomStatus != 2) {
        return this.$message.warning(this.$t("common.请先开启直播"));
      }
      if(this.formLabelAlign.scope.length == 0) {
        return this.$message({
          type: "warning",
          message: this.$t("signIn.必须选择一个范围"),
          duration: 2000,
        });
      }
      if (this.limit > 0) {
        return this.$message({
          type: "warning",
          message: this.$t("signIn.两次签到最小间隔不能小于60秒"),
          duration: 2000,
        });
      }
      
      this.$refs.signIn.validate(async (valid) => {
        if (valid) {
          this.formLabelAlign.range = this.formLabelAlign.scope[0] | this.formLabelAlign.scope[1]
          const { code, msg } = await rollcall.rollcall(this.formLabelAlign);
          if (code == 200) {
            this.$emit("start");
            this.exit();
          } else {
            return this.$message({
              type: "warning",
              message: msg,
              duration: 2000,
            });
          }
        }
      });
    },
    exit() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped lang="scss">
.signin {
  text-align: left;
}

.signHeader ::v-deep {
  .el-dialog__body {
    padding: 57px 50px;
  }
  .el-input__inner {
    background-color: #212442;
    border-color: #525366;
    color: #fff;
  }
  .el-form-item__label {
    padding-right: 0;
    color: #fff;
    font-size: 12px;
  }
  .el-input .el-input__count .el-input__count-inner {
    background-color: #212442;
    color: #acb2bf;
  }
  .el-button--mini {
    border-radius: 6px;
  }
  .el-button--primary.is-disabled {
    background: #3986ee;
    border-color: #3986ee;
    opacity: 0.5;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .inputLong {
    width: 210px;
    &.el-input--small .el-input__inner {
      padding-right: 50px;
      border-color: #525366;
    }
  }
}
.inputTime {
  width: 192px !important;
}

.sign-btn_a {
  text-align: center;
  margin-top: 26px;
}
.signin .second {
  font-size: 12px;
}
.check-label{
 color: #fff;
}
[data-theme=Orange] .check-label{
  color: #3E3F41;
}
// ::v-deep .el-checkbox check-label{
//   font-size: 12px;
// }
</style>
